import { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { FlatEntry } from 'services/cms/flattenContentful';

export function useVideoSrcFromSubject(entry: FlatEntry<Subject> = {}) {
  const { browser } = useBreakpoints();
  const { mobile, tablet } = browser.is;
  const { mobileImage, tabletImage, image } = entry;

  const mobileAsset = mobile && mobileImage;
  const tabletAsset = tablet && (tabletImage || mobileImage);
  const desktopAsset = image;

  const asset = mobileAsset || tabletAsset || desktopAsset;
  const posterSrc = asset?.file?.url;
  const videoSrc = entry.video?.file?.url;

  return { posterSrc, videoSrc };
}
